<template>
  <div class="home mb-20 mt-20">
    <!-- Carrusel de Marcas -->
    <div v-if="brands.length > 0" class="carousel-container">
      <div
        class="carousel"
        :style="{ transform: `translateX(-${currentIndex * (100 / brandsPerSlide)}%)` }"
      >
        <div
          v-for="(brand, index) in brandsToDisplay"
          :key="index"
          class="carousel-item"
        >
          <img :src="brand.logo" :alt="brand.name" class="carousel-img" />
        </div>
      </div>
    </div>

 






<!-- Monturas Oftalmológicas -->
<section class="section">
  <h2 class="section-title">Monturas Oftalmológicas</h2>
  <p class="section-description">Encuentra las mejores monturas oftalmológicas para tus lentes, diseñadas para ofrecer comodidad y estilo.</p>
  <div class="items-container">
    <!-- Aquí irán los items cuando estén disponibles -->
  </div>
  <div class="alert">No hay monturas oftalmológicas disponibles</div>
</section>

<!-- Monturas de Sol -->
<section class="section">
  <h2 class="section-title">Monturas de Sol</h2>
  <p class="section-description">Descubre las monturas de sol más modernas y cómodas para proteger tus ojos mientras luces increíble.</p>
  <div class="items-container">
    <!-- Aquí irán los items cuando estén disponibles -->
  </div>
  <div class="alert">No hay monturas de sol disponibles</div>
</section>

<!-- Provador Virtual -->
<section class="section">
  <h2 class="section-title">Provador Virtual</h2>
  <p class="section-description">Prueba virtualmente nuestras monturas y encuentra la que mejor se adapte a tu rostro, ¡todo desde la comodidad de tu hogar!</p>
  <div class="items-container">
    <!-- Aquí irán los items cuando estén disponibles -->
  </div>
  <div class="alert">No hay items disponibles para el provador virtual</div>
</section>








  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { getBrands, Brand } from "@/services/api/brandServices";

export default defineComponent({
  name: "HomeView",
  setup() {
    const brands = ref<Brand[]>([]); // Marcas
    const currentIndex = ref(0); // Índice actual de las marcas visibles
    const brandsPerSlide = ref(6); // Número de marcas visibles por diapositiva
    const brandsToDisplay = ref<Brand[]>([]); // Las marcas que se muestran en el carrusel

    const ophthalmicFrames = ref<any[]>([]);
    const sunglasses = ref<any[]>([]);
    const virtualTryOnItems = ref<any[]>([]);

    // Cargar marcas al montar el componente
    onMounted(async () => {
      try {
        const data = await getBrands();
        brands.value = data;
        brandsToDisplay.value = [...data, ...data]; // Duplicamos las marcas para el efecto cíclico
        startCarousel(); // Iniciar el carrusel
      } catch (error) {
        console.error("Error al cargar las marcas:", error);
      }
    });

    // Rotar el carrusel cada 3 segundos
    let interval: number;
    const startCarousel = () => {
      interval = setInterval(() => {
        // Verificar si el carrusel ha llegado al final
        if (currentIndex.value + brandsPerSlide.value < brandsToDisplay.value.length) {
          currentIndex.value++;
        } else {
          currentIndex.value = 0; // Reiniciar al principio, creando el efecto cíclico
        }
      }, 3000); // Cambio de imagen cada 3 segundos
    };

    // Limpiar el intervalo al desmontar el componente
    onUnmounted(() => {
      clearInterval(interval);
    });

    return {
      brands,
      brandsToDisplay,
      currentIndex,
      brandsPerSlide
    };
  }
});
</script>

<style scoped>
.home {
  text-align: center;
}

.carousel-container {
  width: 100%;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
}

.carousel {
  display: flex;
  transition: transform 1s ease-in-out;
}

.carousel-item {
  flex: 0 0 16.66%; /* Asegura que haya solo 6 elementos visibles por vez */
  margin: 0 5px;
  display: flex;
  justify-content: center;
}

.carousel-img {
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
}

/* Diseño responsivo */
@media (max-width: 600px) {
  .carousel-item {
    flex: 0 0 45%; /* 2 elementos por fila en pantallas pequeñas */
  }
}

@media (min-width: 600px) and (max-width: 900px) {
  .carousel-item {
    flex: 0 0 30%; /* 3 elementos por fila en pantallas medianas */
  }
}

@media (min-width: 900px) {
  .carousel-item {
    flex: 0 0 16.66%; /* 6 elementos por fila en pantallas grandes */
  }
}



/* Estilo para la sección */
.section {
  padding: 40px 20px;
  margin: 40px 0;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-description {
  font-size: 1.1rem;
  color: #666;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.6;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* Contenedor de los items */
.items-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

/* Estilo para las alertas */
.alert {
  background-color: #f8d7da;
  color: #721c24;
  padding: 15px;
  border: 1px solid #f5c6cb;
  border-radius: 5px;
  margin-top: 20px;
  font-size: 1rem;
  text-align: center;
}

/* Diseño responsivo */
@media (max-width: 768px) {
  .section-title {
    font-size: 1.5rem;
  }

  .section-description {
    font-size: 1rem;
  }

  .alert {
    font-size: 0.9rem;
  }
}

</style>
